import { z } from '@harvestiq/zod';

export const smsSubscribeMessageSchema = z.object({
  orgId: z.string(),
  phoneNumber: z.string().max(12, 'Phone number must be at most 12 characters'), // Twilio sends in E.164 format with '+' sign, e.g. +14017122661. Using 12 to allow only US numbers.
});

export type SmsSubscribeMessage = z.infer<typeof smsSubscribeMessageSchema>;
